import DocViewer from "@cyntler/react-doc-viewer";
import { Image } from "antd";
import React from "react";

const RenderFiles = ({ ext, src, width = null }) => {
  return (
    <>
      {(ext?.toLowerCase() === "png" ||
        ext?.toLowerCase() === "jpeg" ||
        ext?.toLowerCase() === "jpg" ||
        ext?.toLowerCase() === "jfif") && (
        <div>
          <Image
            width={width ? width : null}
            alt="img"
            loading="Loading...."
            src={src}
          />
        </div>
      )}
      {ext?.toLowerCase() === "mp4" && (
        <div>
          <video
            src={src}
            style={{
              border: "1px solid black",
              objectFit: "cover",
              width : width ? width : "100%"
            }}
            {...{
              ...(width ? {} : { height: "300" }),
            }}
            controls
          ></video>
        </div>
      )}

      {ext?.toLowerCase() === "pdf" && (
        <iframe
          style={{ width: "100%" }}
          title="iframe"
          className="iframe"
          width="100%"
          height = "470"
          src={src}
        >
          <p>iframes are not supported by your browser.</p>
        </iframe>
      )}
      {(ext?.toLowerCase() === "doc" || ext?.toLowerCase() === "docx") && (
        <div style={{ flexGrow: 1 }} className="resume">
          <DocViewer
            style={{ width: "100%" }}
            config={{
              header: {
                disableHeader: true,
                disableFileName: true,
              },
            }}
            documents={[
              {
                uri: src,
                fileType: ext,
              },
            ]}
          />
        </div>
      )}
    </>
  );
};

export default RenderFiles;
